// Dashboard entity - contains references to insights and their layouts
export interface Dashboard {
  id: string;
  title: string;
  description?: string;
  defaultTimeRange?: {
    preset: string;
    customDays?: number;
  };
  defaultAttributionPresetId?: string | null;
  tiles: {
    insightId: string;
    layouts: {
      lg: import("./insights").Layout;
      sm: import("./insights").Layout;
    };
  }[]; // Ordered tiles with layouts per breakpoint
  schemaVersion: number;
  createdAt: number;
  updatedAt: number;
}

export const DEFAULT_DASHBOARD_TIME_RANGE: NonNullable<
  Dashboard["defaultTimeRange"]
> = {
  preset: "today",
  customDays: 0,
};

export type CreateDashboardInput = {
  title: Dashboard["title"];
  description: NonNullable<Dashboard["description"]>;
  tiles: Dashboard["tiles"];
  defaultTimeRange?: NonNullable<Dashboard["defaultTimeRange"]> | null;
  defaultAttributionPresetId?: Exclude<
    Dashboard["defaultAttributionPresetId"],
    undefined
  >;
};

// Storage wrapper with version for migration
export interface StoredDashboardsConfig {
  version: number;
  data: Dashboard[];
}

// Storage wrapper for insights library
export interface StoredInsightsLibrary {
  version: number;
  data: import("./insights").InsightConfig[];
}

// Storage keys
export const STORAGE_KEYS = {
  INSIGHTS_LIBRARY: "tracify:insights-library",
  DASHBOARDS: "tracify:dashboards",
  // Legacy key for migration (v1 -> v2)
  DASHBOARD_LAYOUTS_LEGACY: "tracify:dashboard-layouts",
} as const;

// Current versions
export const STORAGE_VERSIONS = {
  INSIGHTS_LIBRARY: 1,
  DASHBOARDS: 3, // v3: tiles with per-breakpoint layouts
} as const;
